import axios from "axios";

// Vide par défaut → appels en même origine (/api), servis par le Worker Cloudflare.
// (On peut surcharger avec REACT_APP_BACKEND_URL pour pointer ailleurs.)
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const postAudit = (data) => axios.post(`${API}/audit-request`, data);
export const postBrochure = (email) => axios.post(`${API}/brochure-request`, { email });
export const postPromoCheckout = (data) => axios.post(`${API}/promo-checkout`, data);
export const postPartner = (data) => axios.post(`${API}/partner-request`, data);

export const IMAGES = {
  hero: "https://images.pexels.com/photos/3747070/pexels-photo-3747070.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  constat: "https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBwZW9wbGV8ZW58MHx8fHwxNzg1ODM1Mjg3fDA&ixlib=rb-4.1.0&q=85",
  reponse: "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjBwZW9wbGV8ZW58MHx8fHwxNzg1ODM1Mjg3fDA&ixlib=rb-4.1.0&q=85",
  meeting: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmclMjBjYWxtfGVufDB8fHx8MTc4NTgzNTI5Mnww&ixlib=rb-4.1.0&q=85",
  keys: "https://images.pexels.com/photos/5474301/pexels-photo-5474301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const LOGO = {
  horizontal: "https://customer-assets-4nw71qhi.emergentagent.net/job_umbo-hauts-france/artifacts/kxod00py_umbo_horizontal.png",
  square: "https://customer-assets-4nw71qhi.emergentagent.net/job_umbo-hauts-france/artifacts/sp3ra875_logo_umbo.png",
};
